'use client'

import React from 'react'

import { Heart } from '../../icons'
import { Container } from './styles'

export interface FavoriteButtonProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Is favorited
   */
  favorited?: boolean

  /**
   * Click handler
   */
  onClick?: React.MouseEventHandler<HTMLButtonElement>

  /**
   * Loading state
   */
  isLoading?: boolean
}

export const FavoriteButton = ({
  className,
  favorited,
  onClick,
  isLoading,
}: FavoriteButtonProps) => {
  const handleClick: React.MouseEventHandler<HTMLButtonElement> =
    React.useCallback(
      (e) => {
        // Stop event bubbling, and prevent default behavior
        // This prevents the browser navigating to the href specified in the FacilityCard prop,
        // when clicking on the favorite button
        e.preventDefault()
        e.stopPropagation()

        if (!isLoading) {
          onClick?.(e)
        }
      },
      [onClick, isLoading],
    )

  return (
    <Container
      role="button"
      title={favorited ? 'お気に入り登録解除' : 'お気に入り登録'}
      className={className}
      onClick={handleClick}
      isLoading={isLoading}
    >
      <Heart selected={favorited} />
    </Container>
  )
}
